import { Theme, darken } from '@mui/material';
import { BrandColors, SessionStore } from '../../constants';
import { makeStyles } from 'tss-react/mui';

export const DialogBoxStyles = makeStyles()((theme: Theme) => {
  const selectedAccessibilityTheme = sessionStorage.getItem(SessionStore.selectedAccessibilityTheme);
  return {
    box: {
      opacity: theme.palette.dialogBox?.opacity,
      top: 40,
      padding: '3rem 1.5rem',
      [theme.breakpoints.up('md')]: {
        top: '50px',
        padding: '1rem',
      },
      backgroundColor: theme?.palette?.dialogBox?.secondaryColor,
      color: darken(theme?.palette?.dialogBox?.primaryColor || BrandColors.white, 0.15),
      borderBottom: theme?.palette?.dialogBox?.border,
      [theme.breakpoints.down('md')]: {
        alignItems: 'initial',
        height: '100%',
        justifyContent: 'initial',
      },
    },
    innerBox: {
      width: '100%',
      textAlign: 'center',
    },
    button: {
      color: `${theme.palette.dialogBox?.secondaryColor}`,
      backgroundColor: `${theme.palette.dialogBox?.primaryColor}`,
      '&:hover': {
        color: `${theme.palette.dialogBox?.primaryColor}`,
        backgroundColor: `${theme.palette.dialogBox?.secondaryColor}`,
      },
    },
    backdrop: {
      backgroundColor: selectedAccessibilityTheme !== '1' ? 'initial' : '',
      zIndex: 50,
    },
  };
});
